(() => {
  class BekFabricSelector {
    constructor(root){
      this.root=root;
      this.wrap=root.querySelector('[data-fabric-selector]');
      this.modal=root.querySelector('[data-fabric-modal]');
      this.input=root.querySelector('[name="shade_fabric"]');
      this.data=window.BEK_FABRIC_DATA?.fabrics||[];
      this.pending=''; this.tone='ALL'; this.query=''; this.lastFocus=null;
      if(!this.wrap||!this.modal||!this.input||!this.data.length) return;
      this.bind(); this.familyChanged(); this.paintCurrent();
    }
    q(s){return this.root.querySelector(s)}
    qa(s){return [...this.root.querySelectorAll(s)]}
    family(){return this.root.querySelector('[name="shade_family"]:checked')?.value||'ROOF_UNDER'}
    collection(){return this.family()==='VERTICAL'?'EZIP':'MARKISE'}
    collectionLabel(){return this.collection()==='EZIP'?'eZip Screen':'Markisenstoff'}
    setText(s,v){this.qa(s).forEach(e=>e.textContent=v)}
    bind(){
      this.q('[data-fabric-open]')?.addEventListener('click',e=>{this.lastFocus=e.currentTarget;this.open()});
      this.qa('[data-fabric-close]').forEach(b=>b.addEventListener('click',()=>this.close()));
      this.q('[data-fabric-search]')?.addEventListener('input',e=>{this.query=e.target.value.trim().toLowerCase();this.render()});
      this.qa('[data-fabric-tone]').forEach(b=>b.addEventListener('click',()=>{this.tone=b.dataset.fabricTone||'ALL';this.qa('[data-fabric-tone]').forEach(x=>x.classList.toggle('is-active',x===b));this.render()}));
      this.q('[data-fabric-grid]')?.addEventListener('click',e=>{const c=e.target.closest('[data-fabric-code]');if(!c)return;this.pending=c.dataset.fabricCode;this.render();this.q('[data-fabric-apply]').disabled=false;});
      this.q('[data-fabric-apply]')?.addEventListener('click',()=>this.apply());
      this.q('[data-fabric-clear]')?.addEventListener('click',()=>{this.pending='';this.input.value='';this.input.dispatchEvent(new Event('change',{bubbles:true}));this.paintCurrent();this.close()});
      this.root.addEventListener('change',e=>{if(e.target.name==='shade_family'){this.familyChanged();}});
      document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!this.modal.hidden)this.close()});
    }
    familyChanged(){
      const col=this.collection();
      const current=this.findByValue(this.input.value);
      if(current&&current.collection!==col){this.input.value='';this.input.dispatchEvent(new Event('change',{bubbles:true}));}
      this.tone='ALL'; this.query='';
      const search=this.q('[data-fabric-search]');if(search)search.value='';
      this.qa('[data-fabric-tone]').forEach(b=>b.classList.toggle('is-active',b.dataset.fabricTone==='ALL'));
      const isEzip=col==='EZIP';
      const tone=this.q('[data-fabric-tone-filter]');if(tone)tone.hidden=!isEzip;
      this.setText('[data-fabric-heading]',isEzip?'Screen auswählen':'Markisenstoff auswählen');
      this.setText('[data-fabric-intro]',isEzip?'Wählen Sie den passenden eZip-Screen.':'Wählen Sie Ihr Dessin direkt aus der aktuellen Markisenstoff-Kollektion.');
      const count=this.data.filter(x=>x.collection===col).length;
      this.setText('[data-fabric-count]',`${count} ${isEzip?'Screens':'Markisenstoffe'}`);
      this.paintCurrent();
    }
    findByValue(v){const code=String(v||'').split(/\s|–/)[0].toUpperCase();return this.data.find(x=>x.code===code)}
    open(){
      const col=this.collection(), isEzip=col==='EZIP';
      this.pending=this.findByValue(this.input.value)?.code||'';
      this.setText('[data-fabric-modal-title]',isEzip?'eZip Screen auswählen':'Markisenstoff auswählen');
      this.setText('[data-fabric-modal-copy]',isEzip?'VD eZip 105 / eZip 125 · Suche nach Screen-Nummer oder Farbe.':'VD Linea / Solara / Luna / Luxora · Suche nach Dessin-Nummer.');
      this.setText('[data-fabric-collection-note]',isEzip?'Nur kompatible eZip-Screens':'Für Unterglas, Aufglas und Gelenkarm');
      const tone=this.q('[data-fabric-tone-filter]');if(tone)tone.hidden=!isEzip;
      const apply=this.q('[data-fabric-apply]');if(apply)apply.disabled=!this.pending;
      this.modal.hidden=false;document.documentElement.classList.add('bek-fabric-lock');this.render();
      setTimeout(()=>this.q('[data-fabric-search]')?.focus(),30);
    }
    close(){this.modal.hidden=true;document.documentElement.classList.remove('bek-fabric-lock');this.lastFocus?.focus?.()}
    visible(){
      const col=this.collection();
      return this.data.filter(f=>{
        if(f.collection!==col)return false;
        if(col==='EZIP'&&this.tone!=='ALL'&&f.tone!==this.tone)return false;
        if(this.query){const hay=`${f.code} ${f.name}`.toLowerCase();if(!hay.includes(this.query))return false;}
        return true;
      });
    }
    swatchStyle(f){return `--fabric-a:${f.colors[0]};--fabric-b:${f.colors[1]};--fabric-pattern:${f.pattern}`}
    esc(s){return String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]))}
    render(){
      const list=this.visible(), grid=this.q('[data-fabric-grid]'), empty=this.q('[data-fabric-empty]');
      this.setText('[data-fabric-results-count]',`${list.length} ${list.length===1?'Stoff':'Stoffe'}`);
      if(empty)empty.hidden=Boolean(list.length);
      if(!grid)return;
      grid.innerHTML=list.map(f=>`<button type="button" class="bek-fabric-card${this.pending===f.code?' is-selected':''}" data-fabric-code="${this.esc(f.code)}" aria-pressed="${this.pending===f.code}"><span class="bek-fabric-swatch bek-fabric-swatch--p${f.pattern}" style="${this.swatchStyle(f)}"><i></i><b>${this.esc(f.code)}</b></span><span class="bek-fabric-card__copy"><strong>${this.esc(f.code)}</strong><small>${this.esc(f.name)}</small></span><span class="bek-fabric-card__check">✓</span></button>`).join('');
    }
    apply(){
      const f=this.data.find(x=>x.code===this.pending);if(!f)return;
      this.input.value=f.name&&f.name!==`Dessin ${f.code}`?`${f.code} – ${f.name}`:f.code;
      this.input.dispatchEvent(new Event('change',{bubbles:true}));
      this.paintCurrent();this.close();
    }
    paintCurrent(){
      const f=this.findByValue(this.input.value), sw=this.q('[data-fabric-current-swatch]');
      if(!sw)return;
      sw.className='bek-fabric-current__swatch bek-fabric-swatch';
      if(f){sw.classList.add(`bek-fabric-swatch--p${f.pattern}`);sw.style.cssText=this.swatchStyle(f);sw.innerHTML='<span></span>';this.setText('[data-fabric-current-title]',f.code);this.setText('[data-fabric-current-subtitle]',f.name);}
      else{sw.removeAttribute('style');sw.innerHTML='<span>?</span>';this.setText('[data-fabric-current-title]','Noch kein Stoff gewählt');this.setText('[data-fabric-current-subtitle]','Sie können die Auswahl auch später mit BEK abstimmen.');}
    }
  }
  const init=()=>document.querySelectorAll('[data-bek-shading-configurator]').forEach(root=>{if(!root.dataset.bekFabricInitialized){root.dataset.bekFabricInitialized='1';new BekFabricSelector(root)}});
  document.addEventListener('DOMContentLoaded',init);document.addEventListener('shopify:section:load',init);
})();
